/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  NotificationTemplateResponse,
  UpdateTemplateRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    NotificationTemplateResponseFromJSON,
    NotificationTemplateResponseToJSON,
    UpdateTemplateRequestFromJSON,
    UpdateTemplateRequestToJSON,
} from '../models/index';

export interface UpdateTemplateOperationRequest {
    templateId: string;
    updateTemplateRequest: UpdateTemplateRequest;
}

/**
 * 
 */
export class NotificationTemplateApi extends runtime.BaseAPI {

    /**
     */
    async findNotificationTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NotificationTemplateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notification-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationTemplateResponseFromJSON));
    }

    /**
     */
    async findNotificationTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NotificationTemplateResponse>> {
        const response = await this.findNotificationTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTemplateRaw(requestParameters: UpdateTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling updateTemplate().'
            );
        }

        if (requestParameters['updateTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTemplateRequest',
                'Required parameter "updateTemplateRequest" was null or undefined when calling updateTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notification-templates/{template_id}`.replace(`{${"template_id"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTemplateRequestToJSON(requestParameters['updateTemplateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTemplate(requestParameters: UpdateTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTemplateRaw(requestParameters, initOverrides);
    }

}
